const GROUPS = [
  { key: "platform", label: "Platform", summary: "Review global intake, provisioning, and platform-level access." },
  { key: "work", label: "Work", summary: "Run the live queue and move the next record forward." },
  { key: "control", label: "Control", summary: "Supervise workload, settings, and launch posture." },
  { key: "health", label: "Health", summary: "Review tenant safety, incidents, and release risk." },
];

const SURFACE_META = {
  platform: {
    navTitle: "Platform",
    groupKey: "platform",
    routeSummary: "Review global intake, approve customer access, and monitor platform notifications.",
    order: 5,
  },
  operator: {
    navTitle: "Inbox",
    groupKey: "work",
    routeSummary: "Work assigned, unassigned, and overdue conversations from one workspace.",
    order: 10,
  },
  manager: {
    navTitle: "Manager",
    groupKey: "control",
    routeSummary: "Command the active queue, workload balance, and reversible bulk actions.",
    order: 20,
  },
  admin: {
    navTitle: "Admin",
    groupKey: "control",
    routeSummary: "Configure tenant settings, onboarding, readiness, and reporting defaults.",
    order: 30,
  },
  support: {
    navTitle: "Support",
    groupKey: "health",
    routeSummary: "Inspect diagnostics, smoke history, delivery issues, and tenant health.",
    order: 40,
  },
  governance: {
    navTitle: "Health",
    groupKey: "health",
    routeSummary: "Review release posture, worker safety, configuration drift, and operational risk.",
    order: 50,
  },
};

export function decorateNavigationSection(section = {}) {
  const base = SURFACE_META[section.key] || {};
  const fallbackGroup = GROUPS.find((item) => item.key === "work") || GROUPS[0];
  const group = GROUPS.find((item) => item.key === base.groupKey) || fallbackGroup;
  return {
    key: section.key || "unknown",
    title: section.title || base.navTitle || "Workspace",
    description: section.description || base.routeSummary || "Workspace surface.",
    navTitle: base.navTitle || section.title || "Workspace",
    groupKey: base.groupKey || group.key,
    groupLabel: group.label,
    groupSummary: group.summary,
    routeSummary: base.routeSummary || section.description || "Workspace surface.",
    order: base.order || 999,
  };
}

export function buildNavigationModel(bootstrap = {}) {
  const sections = Array.isArray(bootstrap.sections) ? bootstrap.sections : [];
  const decorated = sections.map(decorateNavigationSection).sort((left, right) => left.order - right.order);
  const groups = GROUPS.map((group) => ({
    key: group.key,
    label: group.label,
    summary: group.summary,
    items: decorated.filter((item) => item.groupKey === group.key),
  })).filter((group) => group.items.length > 0);
  const groupLabels = groups.map((group) => group.label);
  return {
    groups,
    items: decorated,
    overview: decorated.length
      ? `${bootstrap.full_name || "This user"} can move through ${decorated.length} surface(s) across ${groupLabels.join(
          ", "
        )} on ${bootstrap.entitlements?.plan_label || "the current plan"}.`
      : "No accessible CRM surfaces are available for this role.",
  };
}
